import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { HeatmapActivityOption } from '../types/HeatmapActivity';
import { HeatmapOption, HeatmapOptionKey } from '../types/HeatmapOptionsData';
import { HeatmapTimeRangeOption } from '../types/HeatmapTimeRange';
import { heatmapsApi } from './heatmapsApi';

export type HeatmapsState = {
  availableOptions?: HeatmapOption[];
  currentlySelectedOptions?: Partial<Record<HeatmapOptionKey, HeatmapActivityOption | HeatmapTimeRangeOption>>;
  urlTemplate?: string;
  isHeatmapFilterModalOpen: boolean;
};

export const initialHeatmapsState: HeatmapsState = {
  isHeatmapFilterModalOpen: false
};

export const heatmapsSlice = createSlice({
  name: 'heatmaps',
  initialState: initialHeatmapsState,
  reducers: {
    updateCurrentlySelectedOptions: (state, action: PayloadAction<Record<HeatmapOptionKey, HeatmapActivityOption | HeatmapTimeRangeOption>>) => {
      state.currentlySelectedOptions = { ...state.currentlySelectedOptions, ...action.payload };
    },
    updateIsHeatmapFilterModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isHeatmapFilterModalOpen = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addMatcher(heatmapsApi.endpoints.getHeatmapOptionsData.matchFulfilled, (state, { payload }) => {
      if (payload.options?.length) {
        state.availableOptions = payload.options;
        payload.options.forEach(option => {
          if (option.values.length > 0 && !state.currentlySelectedOptions?.[option.key]) {
            state.currentlySelectedOptions = { ...state.currentlySelectedOptions, [option.key]: option.values[0] };
          }
        });
      }
      if (payload.urlTemplate) {
        state.urlTemplate = payload.urlTemplate;
      }
    });
  }
});

export const { updateCurrentlySelectedOptions, updateIsHeatmapFilterModalOpen } = heatmapsSlice.actions;

export const heatmapsReducer = heatmapsSlice.reducer;
